import type { ReactNode } from "react"

interface MobileLayoutProps {
  children: ReactNode
  className?: string
}

export function MobileLayout({ children, className = "" }: MobileLayoutProps) {
  return <div className={`mx-auto w-full max-w-app px-4 ${className}`}>{children}</div>
}
